'use strict'
// import { Toast } from 'vant'
import md5 from 'js-md5'
/* eslint-disable*/
/**
 * signature签名规则
 * @param {*接口api地址} _uri （不带前后 '/'）
 * @param {*请求方式} _method
 * @param {*post请求参数，post方式签名必要参数} _postdata
 * @param {*get请求业务参数} _param
 */

function getSignature(_uri, _method, _postdata, _param) {
  if (_uri.startsWith('http')) {
    const url = new URL(_uri)
    _uri = url.pathname
  }
  var length = '8'
  const getParam = _param
  // console.log('getParam')
  // console.log(getParam)
  // console.log(_postdata)
  // 随机值（ 毫秒级时间戳+8位随机码（a-z, A-Z, 0-9）例如：1609575455641noCJKVsQ
  var nonce = ''
  nonce = Date.now() + nonce
  var strPol = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  // 秒级时间戳
  var timestamp = ''
  timestamp = Math.ceil(Date.now() / 1000)
  var max = strPol.length - 1

  for (var i = 0; i < length; i += 1) {
    nonce += strPol[Math.ceil(Math.random() * max)]
  }

  var paramsObj = {
    nonce: nonce,
    timestamp: timestamp,
    secretkey: nonce, // X-Terminal = Wap(wap端专用) 时secretkey为nonce 随机值
    uri: _uri,
    http_method: _method.toLocaleUpperCase()
  }
  // console.log(JSON.stringify(_postdata))
  if (_method == 'get' && getParam) {
    paramsObj = Object.assign({}, getParam, paramsObj)
    // console.log(paramsObj, 'paramsObj')
  } else {
    // 如果是post put
    if (_postdata) {
      let urlencodeStr = dealparamsObj(_postdata)
      urlencodeStr = dealStrReplace(urlencodeStr)
      paramsObj.postdata = md5(urlencodeStr)
    }
  }
  let encodeStr = dealparamsObj(paramsObj)
  encodeStr = dealStrReplace(encodeStr)
  var signature = md5(encodeStr)
  return {
    nonce: nonce,
    timestamp: timestamp,
    signature: signature
  }
}
// js字符替换 专门针对php和js urlencode之后字符不一致的替换
function dealStrReplace(str) {
  str = str.replace(/!/g, '%21')
  str = str.replace(/\*/g, '%2A')
  str = str.replace(/\(/g, '%28')
  str = str.replace(/\)/g, '%29')
  str = str.replace(/\（/g, '%EF%BC%88')
  str = str.replace(/\）/g, '%EF%BC%89')
  // str = str.replace(/~/g, '%7E')
  str = str.replace(/'/g, '%27')
  return str
}
// 将json中kv值按照key的字母顺序升序排列，再把所有key=value（value需进行urlencode）以“&”字符连接起来
function dealparamsObj(paramsObj) {
  // console.log(paramsObj)
  var keys = Object.keys(paramsObj).sort()
  var arg_str = ''
  var arg_arr = []
  keys.forEach(function (key) {
    // debugger
    // if (paramsObj[key] === undefined) {
    //   Toast('参数错误！')
    //   return false
    // }
    if (['signature'].indexOf(key) === -1) {
      arg_arr.push(''.concat(key, '=').concat(encodeURIComponent(paramsObj[key])))
    }
  })
  arg_str = arg_arr.join('&')
  // console.log("arg_str",arg_str)
  return arg_str
}
export default getSignature
